
import $ from 'jquery';


function initStandortSearch( input ) {

    $( input ).on( 'input', function () {

        const filter = $.trim( $(this).val() );
        const regexp = new RegExp( filter, 'i' );

        $('.result').find('.input_wrapper label').each(function () {
            if ( filter.length > 1 && $(this).text().search( regexp ) < 0 ) {
                $(this).parent().fadeOut();
            } else {
                $(this).parent().show();
                $(this).closest('.input_wrapper.has_button').addClass('has_result');
            }
        });

    });
}

$( document ).ready( function() {

    const input = document.getElementById( 'searchstandort' );
    if ( input ) {
        initStandortSearch( input );
    }
} );

window.initStandortSearch = initStandortSearch;
export default initStandortSearch;